module.exports = __webpack_public_path__ + "assets/img/c7e14a09ec5fb216e5360d98e85d5f0b.svg";